const SET_MILK_INTERPOLATION = (state, payload) => {
  state.results = payload;
}

export default {
  SET_MILK_INTERPOLATION
}